<template>
    <div class="card bg-light mb-3">
        <div class="row no-gutters">
            <div class="col-xl img-column" v-if="book.cover_url">
                <a :href="linkTo">
                    <img :src="book.cover_url + '?' + book.cover_hash" class="mx-auto d-block cover" />
                </a>
            </div>
            <div class="col-xl">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-9">
                            <a :href="linkTo" class="black">
                                <div class="card-title">
                                    <h3 class="title mincho" v-html="$filters.ruby(book.title)"></h3>
                                    <span class="badge" :class="['badge-' + book.rating.color]" v-if="book.rating">{{book.rating.rating_name}}</span>
                                </div>
                            </a>
                            <a :href="linkTo" class="black">
                                <h6 class="card-subtitle mincho" v-if="book.subtitle">{{book.subtitle}}</h6>
                            </a>
                        </div>
                        <div class="col-lg-3 mt-2" v-if="showFavoite">
                            <button type="button"
                                class="btn btn-sm btn-block"
                                :class="{'btn-outline-success': !book.fan, 'btn-outline-secondary': book.fan}"
                                :disabled="canFavorite"
                                @click="toggleFavorite(book.id)">
                                <span v-if="book.fan">
                                    <i class="fas fa-heart-broken"></i>
                                    お気に入り削除
                                </span>
                                <span v-else>
                                    <i class="fas fa-heart"></i>
                                    お気に入り追加
                                </span>
                            </button>
                        </div>
                    </div>
                    <div class="card-text desc">{{$filters.truncate(book.description, 200)}}</div>
                    <div v-if="book.tags">
                        <span class="badge badge-light badge-pill badge-outlined" v-for="t in book.tags" :key="t.id">
                            {{t.tag_name}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer text-right small" v-if="book.property">
            <ul class="horizontal-list">
                <li v-if="book.property">{{$filters.numberFormat(book.property.published_chars)}} 文字</li>
                <li v-if="book.property">{{$filters.dateFormat(book.property.last_published_at, 'YYYY年MM月DD日')}} 最終更新</li>
                <li v-if="book.property">{{$filters.dateFormat(book.property.first_published_at, 'YYYY年MM月DD日')}} 初回公開</li>
            </ul>
        </div>
    </div>
</template>

<style scoped lang="scss">
.cover {
    object-fit: cover;
    height: 352px;
    width: 250px;
}
.desc {
    margin: 1em 0;
    padding: .7em;
    border-radius: .5rem;
    font-size: .8rem;
}
.img-column {
    max-width: 250px;
}
.profile {
    width: 250px;
    height: 250px;
    object-fit: cover;
}
.profile-column {
    max-width: 280px;
}
.black {
    color: #35393b;
    &:hover {
        color: #2f424b;
        text-shadow: 0 0 9px rgba(0, 0, 127, .2);
        text-decoration: none;
    }
}
@media screen and (max-width: 1200px) {
    .img-column {
        max-width: none;
    }
}
</style>

<script>
export default {
    props: {
        /**
         * novelには以下の読み込みが必須
         * Book::with(["tags", "rating"])
         */
        book: {
            type: Object,
            required: true,
        },
        /**
         * お気に入りボタンの表示
         */
        showFavoite: {
            type: Boolean,
            default: true,
        },
        /**
         * お気に入りに追加できるか
         */
        canFavorite: {
            type: Boolean,
            default: false,
        },
        /**
         * カードのリンク先
         */
        linkTo: {
            type: String,
            required: true,
        }
    },
    methods: {
        async toggleFavorite(book_id) {
            try {
                const favorite = await axios.post("/author/book/favorite/toggle", {'id': book_id});
                alert.msg(favorite.data);
                this.$emit("updated");
            } catch (err) {
                alert.err(err.response);
            }
        }
    },
}
</script>